import React, { useState } from "react";
import { Box, Grid, FormControl, TextField, Autocomplete } from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { useAuth } from "../hooks";
import { notification } from "antd";
import { enviarSms } from "../services/sms.service";
import CustomTextarea from "./CustomTextarea";
import Loader from "./Loader";

export default function AgregarMensaje({
  setReload,
  reload,
  id_expediente,
  setIsVisibleModal,
  oficinasList,
  internalUsersList,
  usersList,
}) {
  const { user } = useAuth();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
  const [selectedOficina, setSelectedOficina] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [fullUsers, setFullUsers] = useState([...usersList, ...oficinasList])
  const [intUsrsList, setInternalUsersList] = useState([...usersList, ...internalUsersList]);
  const onClose = () => {
    setIsVisibleModal(false);
    setTitle("");
    setMessage("");
    setSelectedOficina(null);
    setSelectedUser(null);
  };

  const handleCreateMessageClick = async () => {
    setIsLoading(true);
    let data = {
      id_expediente: Number(id_expediente),
      titulo: title,
      mensaje: message,
      conversa: 1
    };

    if (selectedUser?.id_usuario) {
      data.id_destino = selectedUser.id_usuario;
    } else {
      data.id_oficina_destino = selectedUser.id;
    }

    console.log("data send message", data);

    if (!data.titulo || data.titulo === "") {
      notification["error"]({
        message: "Ingrese un titulo para el mensaje a enviar",
      });
      return;
    }

    if (!data.mensaje || data.mensaje === "") {
      notification["error"]({
        message: "Ingrese un mensaje a enviar",
      });
      return;
    }

    try {
      const result = await enviarSms(data);

      console.log("resultado al crear mensaje:", result);
      setIsLoading(false)
      if (result.data) {
        setReload(!reload);
        setIsVisibleModal(false);
        setTitle("");
        setMessage("");
        setSelectedOficina(null);
        setSelectedUser(null);
      }
    } catch (error) {
      console.log("error create request exp", error);
      setIsLoading(false)
    }
  };

  const handleInputChangeMessage = (event) => {
    const value = event.target ? event.target.value : event;
    setMessage(value);
  };

  const handleInputChangeTitle = (event) => {
    const value = event.target ? event.target.value : event;
    setTitle(value);
  };

  const selectTypeByUser = () => {
    switch (user?.id_tipo_us) {
      case 0:
        return (
          <>
            <FormControl fullWidth>
              <Autocomplete
                size="small"
                options={intUsrsList}
                getOptionLabel={(option) => option.nombre}
                renderOption={(props, option) => (
                  <li {...props}>
                  {option.nombre} <span style={{ marginLeft: '8px', marginRight: '5px' }}> </span> 
                  <strong>[{option.mail}]</strong>  {/* El mail en negrita con espacio */}
                </li>
                )}
                value={selectedUser}
                onChange={(e, value) => setSelectedUser(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccione un usuario"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </>
        );
      case 1:
        return (
          <>
            <FormControl fullWidth>
              <Autocomplete
                size="small"
                options={fullUsers}
                getOptionLabel={(option) => option.nombre}
                renderOption={(props, option) => (
                  <li {...props}>
                    {option.nombre}
                    {option.mail && (
                      <>
                        <span style={{ marginLeft: '8px', marginRight: '5px' }}> </span>
                        <strong>[{option.mail}]</strong>
                      </>
                    )}
                    {!option.mail && (
                      <>
                        <span style={{ marginLeft: '8px', marginRight: '5px' }}> </span>
                        <strong>[OFICINA]</strong>
                      </>
                    )}                    
                  </li>
                )}
                value={selectedUser}
                onChange={(e, value) => setSelectedUser(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccione una oficina"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </>
        );
      case 2:
        return null;
      default:
        return null;
    }
  };

  const disabledButton = () => {
    if (!selectedUser && !isLoading) {
      return true;
    } else {
      return false;
    }
  };

  if(isLoading){
    return <Loader />
  }

  return (
    <>
      <Box p={2}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              label="Titulo"
              size="small"
              name="title"
              value={title}
              onChange={(e) => handleInputChangeTitle(e)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" size="small">
              <CustomTextarea
                rows={4}
                value={message}
                onChange={handleInputChangeMessage}
                label="Mensaje"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            {selectTypeByUser()}
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
              <ButtonComponent
                name="Enviar"
                toAction={handleCreateMessageClick}
                disabled={disabledButton()}
              />
              <div style={{ width: "5px" }}></div>
              <ButtonComponent
                name="Cancelar"
                toAction={onClose}
                color={COLORS.DANGER}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
